export const LOG_MESSAGES = {
  USER_SENT_MESSAGE: 'User sent a message',
  USER_CLICKED_SUGGESTION: 'User clicked a suggestion',
  USER_CLOSED_SNACKBAR: 'User closed the snackbar',
  USER_CLOSED_SIDEBAR: 'User closed the sidebar',
  USER_CLICKED_MENU_ITEM: 'User clicked a menu item',
  USER_TOGGLED_DARK_MODE: 'User toggled the dark mode',
  USER_CLICKED_SIDEBAR_ARROW: 'User clicked the sidebar arrow button',
  USER_CLICKED_USER_MENU: 'User clicked the user menu',
  USER_CLOSED_USER_MENU: 'User closed the user menu',
  USER_ATTEMPTED_LOGIN: 'User attempted to log in',
  USER_LOGGED_OUT: 'User logged out',
  LOGIN_FAILED: 'Login with Okta failed',
  LOGOUT_FAILED: 'Logout with Okta failed',
  USER_SELECTED_FRENCH: 'User selected French',
  USER_SELECTED_ENGLISH: 'User selected English',
  USER_SELECTED_SPANISH: 'User selected Spanish',
  CONVERSATION_ACCESSED: 'User accessed a conversation successfully',
  CONVERSATION_ACCESS_FAILED: 'Error occurred while accessing the conversation',
};
